import {
  PROFESSIONALS_FETCHED_SUCCESS,
  PROFESSIONALS_FETCHED_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const professionalsFetchedAction = (status) => async (dispatch) => {
  try {
    dispatch({
      type: PROFESSIONALS_FETCHED_SUCCESS,
      payload: status,
    });
  } catch (err) {
    log.error('Error dispatching professionals fetched action', err);
    dispatch({
      type: PROFESSIONALS_FETCHED_FAILURE,
      payload: status,
    });
  }
};

export default professionalsFetchedAction;
